import axiosClient from 'config/axios';
import tokenConfig from 'config/auth';

import {
  GET_PROCESSES, ADD_PROCESSES, UPDATE_PROCESS_STEPS, UPDATE_PROCESS_STEP_COMPLETED, DELETE_PROCESSES
} from 'redux/actionTypes';

export const getProcesses = () => (dispatch, getState) => {
  axiosClient
    .get('/api/product-steps', tokenConfig(getState))
    .then(res => {
      dispatch({
        type: GET_PROCESSES,
        payload: res.data
      });
    })
    .catch(err => console.log(err))
};

export const addProcessesSocket = processArray => ({
  type: ADD_PROCESSES,
  payload: processArray
});

export const updateProcessSteps = (updatedSteps) => (dispatch, getState) => {
  axiosClient
    .patch('/api/product-steps/steps', updatedSteps, tokenConfig(getState))
    .then(res => {
      dispatch({
        type: UPDATE_PROCESS_STEPS,
        payload: res.data
      });
    })
    .catch(err => console.log(err))
};

export const updateProcessStepCompleted = (updatedStep) => (dispatch, getState) => {
  axiosClient
    .patch('/api/product-steps/completed', updatedStep, tokenConfig(getState))
    .then(res => {
      dispatch({
        type: UPDATE_PROCESS_STEP_COMPLETED,
        payload: res.data
      });
    })
    .catch(err => console.log(err))
};

export const deleteProcessesSocket = id => ({
  type: DELETE_PROCESSES,
  payload: { id }
});